import React, { useEffect, useState } from 'react';
import Util from '../../../utils/utils';
import * as qs from "query-string";
import {checkUserAgent, openAppZalo, openDeeplink, redirectH5Binding} from '../../CommonFunction';
import {createSession, trackingEventCallAPI} from "../../../api/trackingSDK";
import {EventTrackingList} from "../../../api/const";
import {ContentCenter} from "./ContentCenter/ContentCenter.component";
import ContentFooter from "./ContentFooter/ContentFooter.component";

const MobileHome = ({ bindingInfo }) => {
    const [sessionTracking, setSessionTracking] = useState('');
    const [initialized, setInitialized] = useState(false);

    const handleCreateSession = () => {
        let session = ''
        createSession(res => {
            if (res) {
                setSessionTracking(res)
                session = res;
            }
        })

        return session;
    }
    const sendEventTracking = (session, eventName) => {
        const eventId = EventTrackingList.normalLandingPage.eventId[eventName];
        const metaData = {
            agent: navigator.userAgent,
            requestID: bindingInfo?.binding_token
        }
        trackingEventCallAPI(eventId, session, metaData)
    }

    const handleEventTrackingClientRequest = () => {
        let session = handleCreateSession();
        sendEventTracking(session, 'clientRequest')
    }

    const handleEventTrackingClickOpenApp = (eventName) => {
        const eventId = EventTrackingList.normalLandingPage.eventId[eventName];
        const metaData = {
            agent: navigator.userAgent,
            requestID: bindingInfo?.binding_token
        }
        trackingEventCallAPI(eventId, sessionTracking, metaData)
    }

    const openZPI = () => {
        openAppZalo(bindingInfo);
        handleEventTrackingClickOpenApp("clickButtonOpenAppZalo")
    }

    useEffect(() => {
        if(document.readyState === "complete" ) {
            sendEventTracking(sessionTracking, 'renderUIComplete')
        }
        if (!(Util.getMobileOS() === "Android" && Util.getBrowserName() === "Chrome")) {
            openZPI();
        }
    }, []);

    const mcInfo = Util.getMerchantInfo(bindingInfo);
    if (!initialized) {
        setInitialized(true);
        handleEventTrackingClientRequest();
    }

    return (
        <main>
            <ContentCenter bindingInfo={bindingInfo}/>
            <ContentFooter bindingInfo={bindingInfo} sessionTracking={sessionTracking}/>
        </main>
    );
};

export default MobileHome;
